import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';
import fontService, { FontWeight } from 'services/FontService';
import { Colors } from 'context';

import { Icon, IconNames } from 'atoms';

export interface IInputTag {
  text: string;
  onClick: () => void;
}

/**
 * Метка со своей кнопкой удаления.
 *
 * 0073: крестик — настоящая кнопка с именем «Usuń <текст>». Раньше это был
 * `div` без роли: мышью удалялось, с клавиатуры и читалкой — никак.
 */
export const InputTag = memo(({ text, onClick }: IInputTag) => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Text>{text}</Text>
      <Close
        type="button"
        aria-label={`${t('careerProfile.remove.tag', { name: text })}`}
        onClick={onClick}>
        <Icon name={IconNames.GrayCloseSm} width={16} height={16} />
      </Close>
    </Wrapper>
  );
});

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: max-content;
  cursor: pointer;
  background-color: ${Colors.additional_gray};
  padding: 4px 4px 4px 8px;
  border-radius: 4px;
`;

const Text = styled.div`
  ${fontService.text({ size: 14, lineHeight: 100, weight: FontWeight.regular })};
  margin-right: 4px;
`;

const Close = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${Colors.black};
    outline-offset: 1px;
  }

  &:hover {
    & svg > * {
      transition: 0.5s;
      fill: ${Colors.black};
    }
  }
`;
